import { useTranslation } from 'next-i18next'

import { Size } from '~/statistics/types/profile-card.types'
import { ProductCardSummary } from '~/statistics/types/common.types'

import ActivitySetProgress from '../CircularProgress'

interface Props {
  summary: ProductCardSummary
}

export default function MathVaultActivitySummary({ summary }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const { completedActivitiesCount, totalActivitiesCount } = summary

  const progress = Math.floor((completedActivitiesCount / totalActivitiesCount) * 100)

  return (
    <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
      <p className="text-center">
        <span className="text-purple">{t('activities')}</span>
      </p>
      <ActivitySetProgress hideCheckmark percentage={progress} size={Size.LARGE} />
      <p className="text-center">
        {completedActivitiesCount}/{totalActivitiesCount}
      </p>
    </div>
  )
}
